import { Action } from 'common/interfaces/root';
import { affiliateRateCardActionTypes as TYPES } from '../actions/types';

const initState: AffiliateRateCardModule.AsinsStore = {
  loading: true,
  data: null,
  error: null,
};

export default (state = initState, { type, payload }: Action): AffiliateRateCardModule.AsinsStore => {
  switch (type) {
    case TYPES.ASINS.GET_RECOMMENDED_ASINS:
      return { ...state, loading: true };
    case TYPES.ASINS.GET_RECOMMENDED_ASINS_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.ASINS.GET_RECOMMENDED_ASINS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
